<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M21.002 63.8222L27.7262 35.1547C29.3163 28.3797 35.3583 23.5896 42.3193 23.5896H108.197"
            class="accent-stroke"
            stroke-width="5.07489"
            stroke-miterlimit="10" />
        <path
            d="M55.22 89.205C60.5768 89.205 64.9384 93.5638 64.9384 98.9206C64.9384 104.277 60.5796 108.639 55.22 108.639C49.8603 108.639 45.5044 104.28 45.5044 98.9206C45.5044 93.561 49.8631 89.205 55.22 89.205ZM55.22 88.2183C49.3077 88.2183 44.5176 93.0112 44.5176 98.9206C44.5176 104.83 49.3105 109.626 55.22 109.626C61.1294 109.626 65.9252 104.833 65.9252 98.9206C65.9252 93.0084 61.1322 88.2183 55.22 88.2183Z"
            class="primary-fill" />
        <path
            d="M55.2197 94.2942C57.7713 94.2942 59.8492 96.372 59.8492 98.9236C59.8492 99.9216 59.5362 100.875 58.9413 101.675C58.0588 102.868 56.7027 103.553 55.2197 103.553C52.6682 103.553 50.5903 101.478 50.5903 98.9236C50.5903 97.0036 51.797 95.2612 53.5929 94.5874C54.1117 94.3928 54.6615 94.2942 55.2197 94.2942ZM55.2197 93.3074C54.5262 93.3074 53.8608 93.4342 53.2462 93.6626C51.1175 94.4605 49.6035 96.5158 49.6035 98.9236C49.6035 102.025 52.1184 104.54 55.2197 104.54C57.0692 104.54 58.7129 103.643 59.7336 102.262C60.4243 101.329 60.8331 100.175 60.8331 98.9236C60.8331 95.8223 58.3182 93.3074 55.2169 93.3074H55.2197Z"
            class="primary-fill" />
        <path
            d="M97.7934 102.575H68.0602C68.0602 102.532 68.0743 102.493 68.0884 102.451C68.4042 101.272 68.5677 100.023 68.5536 98.7318C68.486 93.6851 65.5764 89.3066 61.3642 87.099C59.4724 86.0982 57.3043 85.5484 55.0121 85.5766C52.8581 85.6189 50.8282 86.1517 49.0294 87.099C44.7778 89.3348 41.8823 93.7951 41.8823 98.9235C41.8823 100.144 42.0317 101.323 42.3475 102.448C42.3616 102.49 42.3616 102.53 42.3757 102.572H25.8372C23.108 102.572 20.8581 100.46 20.6664 97.7281C20.2435 90.0086 20.001 85.5456 20.049 77.4116C20.1166 71.9787 20.3788 66.3681 21.0498 61.3186"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M18.9195 84.223H21.4175C22.1252 84.223 22.7031 84.7982 22.7031 85.5087V93.0759C22.7031 93.7836 22.128 94.3587 21.4203 94.3587H18.9224C18.2147 94.3587 17.6367 93.7836 17.6367 93.0731V85.5059C17.6367 84.7982 18.2119 84.2202 18.9224 84.2202L18.9195 84.223Z"
            class="primary-fill" />
        <path
            d="M16.9375 36.1246L15.1923 35.9526L14.6623 35.9018C13.9546 35.8342 13.3118 36.3163 13.1765 37.0127L10.842 49.0627C10.687 49.8634 11.2536 50.6218 12.0656 50.698L15.4292 51.0194C16.1876 51.0927 16.8614 50.5344 16.9347 49.776L18.0963 37.616C18.1668 36.8858 17.6536 36.2373 16.9403 36.1246H16.9375Z"
            class="primary-fill" />
        <path
            d="M51.0632 39.6063C51.1337 38.4786 50.2371 37.5256 49.1065 37.5256H40.1522C34.3893 37.5256 30.4196 42.0902 29.7176 47.963L27.6397 73.4615C27.5693 74.3355 28.2572 75.0826 29.134 75.0826H47.4882C48.2607 75.0826 48.9035 74.4793 48.9515 73.7096L51.066 39.6092L51.0632 39.6063Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M47.7825 64.3606L47.2863 71.6374C47.2863 72.5734 46.5278 73.3319 45.5918 73.3319H32.3294C30.0006 73.3319 30.6942 69.8781 30.8803 67.6959L32.3463 50.5992C32.3463 50.2693 32.3633 49.9423 32.3971 49.6208C34.709 55.0087 39.3384 62.3927 47.7853 64.3549L47.7825 64.3606Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M71.2824 72.396H66.6191"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M95.9395 39.615H109.478"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M98.3398 42.6343H114.439"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M96.0156 45.6543H104.936"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M107.814 64.9846L109.14 65.0579C110.82 65.151 112.153 66.5014 112.227 68.1846L112.455 73.4343"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M108.385 68.2915V87.8242"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M105.902 68.3987V88.109"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M103.418 68.5056V88.3935"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M100.938 68.6157V88.6813"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M92.238 93.9706C93.0695 93.9706 93.7435 93.2965 93.7435 92.465C93.7435 91.6335 93.0695 90.9595 92.238 90.9595C91.4065 90.9595 90.7324 91.6335 90.7324 92.465C90.7324 93.2965 91.4065 93.9706 92.238 93.9706Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M101.385 57.0308V61.0427"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M101.643 55.8269H97.2198C96.8072 55.8269 96.4727 56.1614 96.4727 56.574V56.684C96.4727 57.0966 96.8072 57.4311 97.2198 57.4311H101.643C102.056 57.4311 102.391 57.0966 102.391 56.684V56.574C102.391 56.1614 102.056 55.8269 101.643 55.8269Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M95.2703 65.3396C93.8662 66.6168 93.074 68.4296 93.0881 70.3271L93.2629 91.4133"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M107.977 64.9898C107.977 64.9898 103.24 64.9221 99.6426 64.9221C96.0451 64.9221 96.2396 68.249 96.2396 68.249C96.2396 68.249 95.9323 92.053 96.1212 91.8613L94.4098 91.7175C92.3996 91.5484 90.8574 89.868 90.8574 87.8522V69.7574C90.8574 67.3214 92.8338 65.345 95.2698 65.345"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M112.542 75.791C112.781 88.5374 114.366 92.0673 101.856 92.2985H100.424"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M111.412 94.024C112.243 94.024 112.917 93.35 112.917 92.5185C112.917 91.687 112.243 91.0129 111.412 91.0129C110.58 91.0129 109.906 91.687 109.906 92.5185C109.906 93.35 110.58 94.024 111.412 94.024Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M98.2888 94.6525C99.1202 94.6525 99.7943 93.9784 99.7943 93.1469C99.7943 92.3154 99.1202 91.6414 98.2888 91.6414C97.4573 91.6414 96.7832 92.3154 96.7832 93.1469C96.7832 93.9784 97.4573 94.6525 98.2888 94.6525Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M97.7461 57.4788V63.4361"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M88.3631 72.6924H82.0195"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M81.5332 68.4038H86.7744"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M60.5176 68.4038H71.8459"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M77.2936 87.3185C77.3247 87.0619 77.3867 86.5573 77.4346 85.9201C77.9788 78.8547 75.9967 71.3213 77.0061 67.518C77.116 67.1091 77.3275 66.4071 77.9449 65.894C78.5144 65.4203 79.349 65.2371 80.7051 65.2089C82.0697 65.1807 83.079 66.7116 83.2172 67.3121C83.3525 67.9127 83.2989 68.3638 82.9578 68.3638C82.6166 68.3638 81.4973 68.3779 81.4973 68.3779C82.112 70.7546 82.002 72.8466 81.7567 75.3869C81.5114 77.9299 79.9974 86.1964 80.2145 87.3157C80.4316 88.435 80.6515 91.088 80.488 91.3333C80.3245 91.5786 77.8942 91.3051 77.7307 91.3333C77.5671 91.3615 77.2936 87.3157 77.2936 87.3157V87.3185Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M77.2119 90.1663C77.226 87.9108 77.305 87.4935 77.305 87.4935C77.3473 88.0771 77.508 90.4285 77.6038 90.5892C77.7025 90.7499 78.0296 90.1663 78.9825 90.1663H79.1291C80.0849 90.1663 80.364 90.7584 80.4627 90.5977C80.5614 90.437 80.2005 88.0743 80.2428 87.4907C80.2428 87.4907 80.801 88.7764 80.8659 90.1635C80.9561 92.0468 80.223 92.6474 79.318 92.7968C79.1714 92.8137 78.9064 92.8165 78.7936 92.7968C77.9111 92.6474 77.1978 92.0468 77.2091 90.1663H77.2119Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M76.1563 87.3185C76.1196 87.0506 76.0379 86.3965 75.9815 85.5648C75.5107 78.8039 77.4448 71.2875 76.4439 67.518C76.3339 67.1035 76.1196 66.4071 75.505 65.894C74.9355 65.4203 74.101 65.2371 72.7449 65.2089C71.3803 65.1807 70.3709 66.7116 70.2328 67.3121C70.0974 67.9127 70.151 68.3638 70.4922 68.3638C70.8333 68.3638 71.9526 68.3779 71.9526 68.3779C71.338 70.7546 71.4479 72.8466 71.6932 75.3869C71.9385 77.9299 73.4525 86.1964 73.2354 87.3157C73.0183 88.435 72.7984 91.088 72.9619 91.3333C73.1255 91.5786 75.5558 91.3051 75.7193 91.3333C75.8828 91.3615 76.1563 87.3157 76.1563 87.3157V87.3185Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M76.2376 90.1663C76.2235 87.9108 76.1446 87.4935 76.1446 87.4935C76.1023 88.0771 75.9416 90.4285 75.8457 90.5892C75.747 90.7499 75.42 90.1663 74.467 90.1663H74.3204C73.3647 90.1663 73.0855 90.7584 72.9869 90.5977C72.8882 90.437 73.2491 88.0743 73.2068 87.4907C73.2068 87.4907 72.6485 88.7764 72.5837 90.1635C72.4935 92.0468 73.2265 92.6474 74.1315 92.7968C74.2781 92.8137 74.5432 92.8165 74.6559 92.7968C75.5384 92.6474 76.2517 92.0468 76.2404 90.1663H76.2376Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M72.0371 59.1842C72.2965 58.9079 72.5051 58.8064 72.8378 58.8064H80.14C80.4389 58.8064 80.7913 58.7585 81.1465 58.9418"
            fill="white" />
        <path
            d="M72.0371 59.1842C72.2965 58.9079 72.5051 58.8064 72.8378 58.8064H80.14C80.4389 58.8064 80.7913 58.7585 81.1465 58.9418"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M82.6461 61.3157C84.5718 64.8455 84.5013 66.4047 84.5013 68.4205H83.3961C83.1311 65.0232 78.558 65.587 76.7649 65.5927H76.7226C74.9295 65.587 70.3198 65.0232 70.0548 68.4205H68.9496C68.9496 66.4131 68.8791 64.8625 70.7709 61.3777"
            fill="white" />
        <path
            d="M82.6461 61.3157C84.5718 64.8455 84.5013 66.4047 84.5013 68.4205H83.3961C83.1311 65.0232 78.558 65.587 76.7649 65.5927H76.7226C74.9295 65.587 70.3198 65.0232 70.0548 68.4205H68.9496C68.9496 66.4131 68.8791 64.8625 70.7709 61.3777"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M85.9973 49.8044C86.0819 50.467 86.1354 51.0196 86.1749 51.7724C86.2567 53.2666 86.2144 54.6115 86.1157 55.7674C86.0819 56.1819 85.955 56.5794 85.7492 56.9403C85.1628 57.9609 84.4015 59.1169 83.426 60.2897C82.2419 61.7135 81.0634 62.7736 80.0625 63.5489C79.9018 63.673 79.7213 63.7717 79.5268 63.8393C77.7309 64.4681 76.7864 65.2208 74.5591 64.8177C74.4463 64.7979 74.3983 64.6626 74.4745 64.5724C74.7198 64.2792 75.4133 64.0198 75.8954 63.8732C75.8954 63.8732 77.635 63.1824 78.4977 62.4325"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M75.8828 63.8509C74.9918 63.834 74.1432 63.7466 73.3453 63.2927C72.2176 62.6498 71.118 61.7053 70.2102 60.7834C68.7187 59.2694 67.6417 57.1887 67.2667 55.0995C66.9904 53.5714 66.9876 51.9954 67.2526 50.4673"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M70.0096 51.2788C69.9137 53.1819 69.9137 55.0258 70.7229 56.8696C71.876 59.5199 73.9483 62.0545 76.7564 63.1907"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M78.7163 40.075C78.7163 40.075 78.6092 41.4734 80.2078 41.651C80.501 41.6848 80.8365 41.7271 81.1833 41.7807C81.5639 41.8371 81.9614 41.9019 82.3421 41.9639"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M82.2686 40.2639C80.3035 42.3136 78.189 44.7524 76.0857 47.6084C73.8358 50.6618 72.0427 53.5883 70.6133 56.2188"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M85.6094 40.3342C83.2637 42.9196 80.7488 45.9956 78.2649 49.5959C76.0602 52.7931 74.2558 55.8606 72.7812 58.6687"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M80.0543 34.7914C80.0543 35.5752 79.9246 35.86 79.9246 36.2913C79.9246 36.7227 79.8936 38.1775 79.4989 39.0741C79.1042 39.9706 78.5516 40.2215 77.9961 40.2215C77.4407 40.2215 76.4483 40.1257 75.501 38.6568C74.5537 37.1879 74.8751 34.7125 75.8027 33.8751C76.578 33.1731 78.7066 33.2238 79.5609 33.8131C79.9923 34.1119 80.0543 34.4503 80.0543 34.7942V34.7914Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M82.3452 41.9639C83.9523 42.3078 85.2689 43.4497 85.8413 44.9891L87.1269 48.4625C87.1269 48.4625 86.2755 50.1457 83.645 50.9013C81.5643 51.5018 81.3218 51.2396 81.3133 51.1043L81.2992 50.8308L81.2598 50.4925"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M68.8156 59.1902L65.5 65.1588"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M77.8301 62.915C78.6787 62.4075 79.4935 61.5476 80.5226 60.3324C81.8646 58.7479 82.764 57.2029 83.3589 55.9708C83.4576 55.0573 83.5168 53.9606 83.4548 52.7229C83.4237 52.1111 83.3673 51.5359 83.294 51.0002"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M80.4015 40.7598C80.4156 40.7034 80.441 40.6442 80.4776 40.585C81.3206 39.305 81.3883 37.5992 81.1204 36.1303C81.0528 35.761 80.9569 35.3945 80.83 35.0364C80.0688 32.888 77.537 31.8477 75.5099 32.888C75.0277 33.1362 74.7486 33.3053 74.3934 33.7028C74.3454 33.7564 74.2947 33.8128 74.165 33.9679C73.8859 34.3513 73.587 34.8926 73.0175 35.9612C72.4536 37.0156 71.8813 38.0842 71.2977 38.7665C69.6766 40.6611 67.9539 41.0925 63.6431 41.2334C57.2121 41.4449 56.2873 46.7397 59.944 48.7978C63.316 50.6953 66.829 48.7725 67.3562 48.4623C67.4098 48.4313 67.4605 48.4003 67.5141 48.3749L68.1738 48.0225C68.3232 47.4473 68.4924 46.8806 68.6982 46.3224C68.6869 45.6514 68.9012 45.017 69.1691 44.3968V44.3855C69.1832 44.3122 69.1944 44.2361 69.2085 44.1628C69.2367 44.019 69.31 43.9231 69.4031 43.8667C69.451 43.7624 69.4989 43.6581 69.544 43.5538C69.9782 42.5839 70.7564 42.0116 71.7939 41.7832C72.6538 41.5943 73.6265 41.7071 74.4329 41.3039C74.8276 41.1065 75.0052 40.8161 75.0841 40.3904C75.1884 39.8378 75.3012 39.2599 75.1349 38.7101C75.0869 38.5522 75.1151 38.4197 75.1856 38.3182C75.1715 38.2364 75.1659 38.1547 75.1687 38.0701C75.1687 38.0109 75.1772 37.9517 75.1884 37.8953C75.1631 37.7205 75.1349 37.5485 75.1067 37.3793C75.1913 37.1453 75.2702 36.8634 75.3351 36.5279C75.7213 34.4923 77.8415 34.1145 78.067 34.0778C78.0868 34.0835 78.1065 34.0863 78.1234 34.0919C78.3321 34.1934 79.3583 34.7855 79.4655 36.604C79.5951 38.8116 79.1328 39.4234 79.1328 39.4234L79.2145 39.3952C79.1751 39.4939 79.1356 39.5897 79.0877 39.6828C79.0172 39.8237 78.8903 39.8998 78.7521 39.928C78.7493 39.9337 78.7465 39.9393 78.7409 39.945C78.5153 40.2551 78.6478 40.2805 78.4843 40.2974C78.5604 40.3453 78.6281 40.4073 78.6845 40.4806C78.8677 40.7259 79.0172 40.991 79.1046 41.2842C79.1328 41.3744 79.1328 41.4618 79.1102 41.5436C79.2004 41.5999 79.2907 41.662 79.3696 41.7268L80.159 40.974C79.7981 41.3603 80.2549 40.8979 80.3902 40.7626L80.4015 40.7598Z"
            class="primary-fill" />
        <path
            d="M71.8703 50.639C71.8111 51.0168 71.8872 51.4679 71.7519 51.7414L67.2521 50.467C65.9101 50.1512 65.2701 48.6118 65.9975 47.439C66.7164 46.2802 67.5707 44.9861 68.222 44.2446C69.595 42.6799 70.4493 41.8763 72.1071 41.7805C73.7649 41.6846 74.7601 40.7373 74.7601 40.7373C75.0985 41.0362 75.4988 41.4534 75.8738 42.0032C76.4715 42.8857 76.7393 43.7399 76.869 44.3123"
            fill="white" />
        <path
            d="M71.8703 50.639C71.8111 51.0168 71.8872 51.4679 71.7519 51.7414L67.2521 50.467C65.9101 50.1512 65.2701 48.6118 65.9975 47.439C66.7164 46.2802 67.5707 44.9861 68.222 44.2446C69.595 42.6799 70.4493 41.8763 72.1071 41.7805C73.7649 41.6846 74.7601 40.7373 74.7601 40.7373C75.0985 41.0362 75.4988 41.4534 75.8738 42.0032C76.4715 42.8857 76.7393 43.7399 76.869 44.3123"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M77.4121 43.1309C77.508 42.8687 77.6659 42.5191 77.9337 42.161C78.303 41.6648 78.7203 41.3603 78.9994 41.1912"
            fill="white" />
        <path
            d="M77.4121 43.1309C77.508 42.8687 77.6659 42.5191 77.9337 42.161C78.303 41.6648 78.7203 41.3603 78.9994 41.1912"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M67.8926 66.9462C68.2563 65.8833 68.7694 64.6597 69.5081 63.3713C69.9028 62.6833 70.3116 62.0631 70.712 61.5161"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M15.293 38.5999L16.3361 33.0035C16.7562 30.7423 18.7298 29.1042 21.0304 29.1042H29.5872"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
